module.exports = __webpack_public_path__ + "d3ce28cbf6aba8c7335238ae843d5330.png";